import { faFire } from '@fortawesome/pro-solid-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Pill } from '@/components/ui/pill/pill.component';
import { Icon } from '@/components/ui/icon.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { currencyFormatter } from '@/utils/formatters/currency';

interface SearchPromotionalPricePillProps {
  originalPrice: number;
  promotionalPrice: number;
}

export const SearchPromotionalPricePill = ({
  originalPrice,
  promotionalPrice,
}: SearchPromotionalPricePillProps) => {
  return (
    <div className="mb-4" data-testid={DataTestIdEnum.SEARCH_CARD_PROMOTIONAL_PILL}>
      <Pill variant="search" asChild>
        <div>
          <span className="flex h-4 w-4 items-center justify-center">
            <Icon icon={faFire} size="xs" />
          </span>
          <Typography as="span" variant={TypographyVariant.BODY_TEXT} className="text-pink-700">
            De
            {' '}
            <Typography as="span" variant={TypographyVariant.BODY_TEXT} className="line-through text-pink-700">
              {currencyFormatter(originalPrice, { symbol: false })}
            </Typography>
            {' '}
            por
            {' '}
            <Typography as="span" variant={TypographyVariant.BODY_TEXT} className="font-bold text-pink-700">
              {currencyFormatter(promotionalPrice)}
            </Typography>
          </Typography>
        </div>
      </Pill>
    </div>
  );
};
